import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';

export default function GuideCommentModal({
  show,
  onHide,
  initialBody = '',
  quote = '',
  saving = false,
  onSave
}) {
  const [body, setBody] = useState(initialBody || '');

  useEffect(() => {
    if (show) setBody(initialBody || '');
  }, [show, initialBody]);

  const handleSave = () => {
    const trimmed = body.trim();
    if (!trimmed) return;
    onSave?.(trimmed);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton className="border-0">
        <div className="d-flex flex-column align-items-start w-100">
          <Modal.Title>{initialBody ? 'Edit comment' : 'Add comment'}</Modal.Title>
          <div className="text-hl" />
        </div>
      </Modal.Header>
      <Modal.Body>
        {quote ? (
          <blockquote className="guides-comment-quote small text-muted mb-3">
            {quote.length > 160 ? `${quote.slice(0, 160)}…` : quote}
          </blockquote>
        ) : null}
        <Form.Group>
          <Form.Label className="small text-muted">Comment</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Write your note…"
            autoFocus
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="outline-secondary" size="sm" onClick={onHide} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          onClick={handleSave}
          disabled={saving || !body.trim()}
        >
          {saving ? <Spinner size="sm" /> : 'Save comment'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
